import { MEDIA_FIELDS } from "./media";

export const GALLERY = `gallery {
  image {
    ${MEDIA_FIELDS}
  }
}`;

export const VARIATION_GALLERY = `variationGallery {
  image {
    ${MEDIA_FIELDS}
  }
}`;